import { useState, useRef, useEffect } from "react";
import { useIdleTimer } from "react-idle-timer";
import { API_LINKS } from "../../constants/api";
import { IDLE_TIMER_TIMEOUT_MS } from "../../constants/idleTimer";
import { getPing } from "../../api/ping";

const timeout = IDLE_TIMER_TIMEOUT_MS;
const promptBeforeIdle = 120000;
//const promptBeforeIdle = parseInt(import.meta.env.VITE_IDLE_TIMER_PROMPT_BEFORE_IDLE ?? "12000");
const debounce = 0;
const eventsThrottle = timeout / 4;

export default function SignOutWarningModal() {
  // state and ref
  const [countdown, setCountdown] = useState<number>(-1);
  const dialog = useRef<HTMLDialogElement>(null);

  // timer function and handlers
  function onAction() {
    // ping server here
    // TODO: to be replaced with actual endpoint
    getPing().then((value) => value && console.log("user and idle check"));
  }

  function onIdle() {
    dialog.current?.close();
    // location.assign() rather than assigning to location.href: identical
    // navigation, but not a write to a global that react-hooks/immutability
    // has to reason about.
    window.location.assign(API_LINKS.logout + "?messageId=17");
  }

  function onPrompt() {
    setCountdown(Math.ceil(getRemainingTime() / 1000));
    dialog.current?.showModal();
  }

  const { getRemainingTime, start } = useIdleTimer({
    onAction,
    onIdle,
    onPrompt,
    promptBeforeIdle,
    timeout,
    debounce,
    eventsThrottle,
    stopOnIdle: true,
  });

  // other handlers
  function onSignOut() {
    dialog.current?.close();
    window.location.href = API_LINKS.logout;
  }

  function onCancelSignOut() {
    dialog.current?.close();
    setCountdown(-1);
    start();
  }

  useEffect(() => {
    if (countdown > -1) {
      const interval = setInterval(() => {
        setCountdown(Math.ceil(countdown - 1));
      }, 1000);

      if (countdown === 0) {
        clearInterval(interval);
      }

      return () => {
        clearInterval(interval);
      };
    }
  }, [countdown]);

  return (
    <>
      <dialog
        ref={dialog}
        className="border border-secondary-subtle p-0 shadow-lg"
      >
        <h4 className="c-modal-header fw-semibold">Er du her stadig?</h4>
        <div className="d-flex flex-column p-4">
          <p>
            Du har været inaktiv i længere tid og din session er ved at udløbe.
          </p>
          <p className="pb-4">
            Du bliver logget ud om {Math.ceil(getRemainingTime() / 1000)}{" "}
            sekunder, hvis du ikke foretager dig noget.
          </p>
          <div className="d-flex flex-row align-items-center justify-content-between gap-4">
            <button className="btn btn-secondary w-100" onClick={onSignOut}>
              Log ud
            </button>
            <button className="btn btn-primary w-100" onClick={onCancelSignOut}>
              Forbliv logget ind
            </button>
          </div>
        </div>
      </dialog>
    </>
  );
}
